import { AppState } from '../../../../store/app.state'

import * as fromMembers from '../reducers/members.reducer'

export const getMembersState = (state: AppState) => state.members

export const {
  selectIds: getMembersIds,
  selectEntities: getMembersEntities,
  selectAll: getMembersSelector,
  selectTotal: getTotalMembers,
} = fromMembers.adapter.getSelectors(getMembersState)




// WEBPACK FOOTER //
// ./src/app/shared/team/store/selectors/members.selectors.ts